export default {
  errors: {
    emailAlreadyRegistered: 'Email already registered, please try logging in.',
    invalidEmail: 'Invalid email, please try again.'
  },
  title: 'Sign up',
  subtitle: 'Create a new Vamoz account',
  success: {
    title: 'Check your email ✉️',
    message:
      "We've sent you an email with a link to verify your account. The email may take a few minutes to arrive. Please also check your spam folder."
  },
  confirmation: {
    confirmed: {
      title: 'Email confirmed!',
      message: 'Your email has been confirmed. You can now log in to Vamoz.'
    },
    alreadyConfirmed: {
      title: 'Link already used',
      message:
        'This confirmation link has already been used or is currently being processed. If your account is ready, you can log in below.'
    },
    expired: {
      title: 'Confirmation link expired',
      message:
        "Return to your company's signup link and submit your email again. Contact your company administrator if you no longer have the link."
    },
    invalid: {
      title: 'Invalid confirmation link',
      message:
        'Open the latest confirmation email you received or request a new email from your company signup link.'
    },
    unavailable: {
      title: 'Confirmation temporarily unavailable',
      message:
        'Please try this link again in a few minutes. Contact support if the problem continues.'
    }
  },
  goToLogin: 'Go to login',
  button: 'Signup',
  allowedDomains: 'Allowed domains: {domains}',
  help: 'Help',
  instructions: {
    title: 'Signup Instructions',
    subtitle: 'Please follow these three steps to sign up to Vamoz.',
    step1: 'Enter your email address (from an allowed domain)',
    step2: 'Check your email (may take a few minutes to arrive)',
    step3: 'Click the link in the email to confirm your email address',
    spamFolder:
      "If you don't see the email in your inbox, please check your spam folder."
  }
};
